import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

import escoger from "../../helpers/contribuyente/concesiones/escoger";

import obtenerModalidad from "../../helpers/catalogos/metodos/obtenerModalidad";
import obtenerSubmodalidad from "../../helpers/catalogos/metodos/obtenerSubmodalidad";
import obtenerContribuyente from "../../helpers/contribuyente/contribuyente/obtenerContribuyente";

import obtenerSinConcesion from "../../helpers/contribuyente/contribuyente/obtenerSinConcesion";


export default function Lista(props) {

    const rows = [];
    const idConcesionActual = props.data?.concesionActual?.idConcesion;
    function createData(concesion, placas, modalidad, submodalidad) {
        return { concesion, placas, modalidad, submodalidad };
    }

    props.data?.concesiones?.forEach(item => {
        rows.push(
            createData(
                item.idConcesion,
                item.seriePlaca,
                obtenerModalidad(item.idModalidad, props.catalogos?.modalidades),
                obtenerSubmodalidad(item.idSubmodalidad, props.catalogos?.submodalidades)
            )
        );
    });

    function handleChange(e) {
        if (!e.target.checked) {
            obtenerSinConcesion(props.data.contribuyente.idContribuyente, props.data, props.setData);
        }
        else {
            obtenerContribuyente(props.data.contribuyente.idContribuyente, props.setData);
        }
        props.setChecked(e.target.checked);
    };

    return (
        <>
            {/* (props.data?.contribuyente?.idOperador !== 0) &&  */(props.data?.concesiones?.length > 0) &&
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={props.checked}
                                onChange={handleChange} />
                        }
                        label="Concesión Activa" />
                </FormGroup>
            }

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }}>
                    <TableHead
                        style={{ backgroundColor: "#D4C19C" }} sx={{ color: "white" }}>
                        <TableRow>
                            <TableCell align="left" color="white"><strong style={{ color: "White" }}>SELECCIONAR</strong></TableCell>
                            <TableCell align="left"><strong style={{ color: "White" }}>AUTORIZACIÓN</strong></TableCell>
                            <TableCell align="left"><strong style={{ color: "White" }}>PLACAS</strong></TableCell>
                            <TableCell align="right"><strong style={{ color: "White" }}>MODALIDAD</strong></TableCell>
                            <TableCell align="right"><strong style={{ color: "White" }}>SUBMODALIDAD</strong></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row) => (
                            <TableRow
                                key={row.concesion}
                                className={`tabla ${Number(row.concesion) === idConcesionActual && "filaActiva"}`}
                                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                onClick={() => escoger(row.concesion, props.data, props.setData, props.setChecked)}
                            >
                                <TableCell align="left" className="tablaTexto"><span className="material-icons">check_box</span></TableCell>
                                <TableCell component="th" scope="row" className="tablaTexto">{row.concesion}</TableCell>
                                <TableCell align="left" className="tablaTexto">{row.placas || "-"}</TableCell>
                                <TableCell align="right" className="tablaTexto">{row.modalidad}</TableCell>
                                <TableCell align="right" className="tablaTexto">{row.submodalidad}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    )
}